var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 0.998936C9.31777 0.998936 6.26568 2.26327 4.0152 4.51365C1.76482 6.76403 0.500488 9.81651 0.500488 12.9989C0.500488 16.1813 1.76482 19.2337 4.0152 21.4841C6.26558 23.7345 9.31806 24.9988 12.5004 24.9988C15.6828 24.9988 18.7352 23.7345 20.9857 21.4841C23.2361 19.2337 24.5004 16.1813 24.5004 12.9989C24.4969 9.81736 23.2314 6.76698 20.9818 4.51746C18.7321 2.26794 15.6818 1.00241 12.5003 0.99884L12.5004 0.998936ZM12.5004 22.3323C10.025 22.3323 7.65092 21.349 5.90092 19.5987C4.15092 17.8483 3.1673 15.4744 3.1673 12.9991C3.1673 10.5238 4.15054 8.1496 5.90092 6.3996C7.6513 4.6496 10.0252 3.66598 12.5004 3.66598C14.9757 3.66598 17.35 4.64922 19.1 6.3996C20.85 8.14998 21.8336 10.5238 21.8336 12.9991C21.8308 15.4736 20.8466 17.8458 19.0968 19.5958C17.347 21.3458 14.9748 22.3298 12.5001 22.3326L12.5004 22.3323Z",
    fill: "#84B0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8339 12.447V7.66558C13.8339 7.1892 13.5798 6.7491 13.1672 6.51082C12.7547 6.27272 12.2465 6.27272 11.8339 6.51082C11.4213 6.7491 11.1672 7.1892 11.1672 7.66558V12.9989C11.1672 13.3525 11.3079 13.6916 11.5579 13.9416L14.2245 16.6083C14.5633 16.9353 15.0493 17.0596 15.5033 16.9351C15.9574 16.8107 16.3123 16.4558 16.4368 16.0017C16.5612 15.5476 16.437 15.0616 16.1099 14.7229L13.8339 12.447Z",
    fill: "#84B0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.f1d41dbd9044b4c7ad225715bca2e78f.svg";
export { ForwardRef as ReactComponent };